module.exports = __webpack_public_path__ + "static/media/Sorteo-cardoso.e2df7689.jpg";